var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTbd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carbon:enterprise"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.509766,
    width: 80,
    height: 80,
    rx: 10,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1261162747"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.4531 26.4629L29.9654 26.4629L29.9654 33.4874L26.4531 33.4874L26.4531 26.4629ZM26.4531 36.9997L29.9654 36.9997L29.9654 44.0243L26.4531 44.0243L26.4531 36.9997ZM36.99 26.4629L40.5022 26.4629L40.5022 33.4874L36.99 33.4874L36.99 26.4629ZM36.99 36.9997L40.5022 36.9997L40.5022 44.0243L36.99 44.0243L36.99 36.9997ZM26.4531 47.5366L29.9654 47.5366L29.9654 54.5611L26.4531 54.5611L26.4531 47.5366ZM36.99 47.5366L40.5022 47.5366L40.5022 54.5611L36.99 54.5611L36.99 47.5366Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M65.0879 36.9994C65.0879 36.0679 64.7178 35.1746 64.0592 34.5159C63.4005 33.8572 62.5071 33.4872 61.5756 33.4872L51.0388 33.4872L51.0388 19.4381C51.0388 18.5065 50.6687 17.6132 50.0101 16.9545C49.3514 16.2958 48.458 15.9258 47.5265 15.9258L19.4283 15.9258C18.4968 15.9258 17.6034 16.2958 16.9447 16.9545C16.2861 17.6132 15.916 18.5065 15.916 19.4381L15.916 65.0977L65.0879 65.0977L65.0879 36.9994ZM19.4283 19.4381L47.5265 19.4381L47.5265 61.5854L19.4283 61.5854L19.4283 19.4381ZM51.0388 61.5854L51.0388 36.9994L61.5756 36.9994L61.5756 61.5854L51.0388 61.5854Z",
    fill: "#240b3b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbd);
export default __webpack_public_path__ + "static/media/TBD.aca39d04a66e184c94d5953e5cbab38e.svg";
export { ForwardRef as ReactComponent };